"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Fapi_1 = __importDefault(require("./Fapi"));
const consts_1 = __importDefault(require("../Authentication/consts"));
class Api {
    constructor() {
        this.token = localStorage.getItem(consts_1.default.TOKEN_KEY);
        this.baseUri = "https://api.fozg.net/";
    }
    get_current_user() {
        return new Fapi_1.default({ baseUri: "", token: this.token }).getData({
            path: consts_1.default.API_CURRENT_USER,
        });
    }
}
exports.default = Api;
//# sourceMappingURL=index.js.map